export default __webpack_public_path__ + "static/GatheringInfoStep-a0eff87d62b84850e993c675e1b800d0.png";